/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Directive, ViewContainerRef } from '@angular/core';
import { logger } from '@touchplan/logging';

@Directive({
	selector: '[edit-type]',
})
export class EditType {
	constructor(public viewContainerRef: ViewContainerRef) {
		logger.log('EditType');
	}
}
